import React from 'react';
import AlertMessage from '../AlertMessage';

/**
 * Displays the Medicare Medical Necessity disclaimer.
 * 
 * @param props.children Optional elements to add to the end of the disclaimer
 */
export default function MedicalNecessityDisclaimer({ children }) {
	return (
		<AlertMessage type="info">
			<div className="small">
				<span>This order is being placed for a Medicare or Tricare patient. Please refer to the definition of medical necessity below:</span>
				<br /><br />
				<strong>Definition of Medical Necessity</strong>
				<br />
				All claims submitted to Medicare/Medicaid for Genova Diagnostics' laboratory services must be for tests
				that are medically necessary. "Medically necessary" is defined as a test or procedure that is reasonable
				and necessary for the diagnosis or treatment of illness or injury or to improve the functioning of a
				malformed body member. Consequently, tests performed for screening purposes will not be reimbursed by
				the Medicare program. Physicians may deem it medically necessary to order a single test or a portion of
				a profile.
				{!children && <MedicareObligationText />}
				{children}
			</div>
		</AlertMessage>
	);
}

/**
 * This text needs to be included whenever the MedicalNecessityDisclaimer is displayed. 
 * However, the way some components pass in {children} means we can't always place this text where it needs to be.
 * Export the text so a caller can place it in the appropriate place.
 */
export function MedicareObligationText() {
	return (
		<div>
			<br />
			<strong>Please note</strong>: Genova Diagnostics is obligated on occasion by the Centers for Medicare &
			Medicaid Services (CMS) to provide your office medical records documenting medical necessity. If needed,
			Genova will request these records from you. Failure to comply with this request may result in your direct
			liability to CMS, as well as removal from Genova's Medicare ordering privileges. Please visit the{' '}
			<a
				href="/files/medicare/ProviderComplianceLabServices_Fact_Sheet_ICN909221.pdf"
				target="_blank"
				title="Complying With Laboratory Services Documentation Requirements"
			>
				<span className="fa fa-external-link pr-5"></span>
				CMS guide
			</a>{' '}
			for additional information.
		</div>
	);
}